import React from "react";
import Availability from "./Availability";
import { useDispatch, useSelector } from "react-redux";
import WorkingHours from "./WorkingHours";
import PushNotification from "./PushNotification";

export default function DashboardPreferences() {
  const dispatch = useDispatch();
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  return (
    <div className="preference">
      <h2 className="font-42">Preferences</h2>
      <div className="account-preference col-md-6">
        {/* <>
          <h4>Account preferences</h4>
          <div className="form-group">
            <h5>Account status</h5>
            <label>Set account status</label>
            <select className="form-control">
              <option value="1">Active</option>
              <option value="1">In Active</option>
            </select>
          </div>
          <div className="form-group">
            <h5>Show currency in</h5>
            <label>Currency</label>
            <select className="form-control">
              <option value="1">USD</option>
              <option value="1">In Active</option>
            </select>
          </div>
          <div className="form-group">
            <h5>Timezone</h5>
            <label>Timezone</label>
            <select className="form-control">
              <option value="1">+5.30 IST(Kolkata)</option>
              <option value="1">In Active</option>
            </select>
          </div>
          <div className="form-group">
            <h5>Language</h5>
            <label>View website in</label>
            <select className="form-control">
              <option value="1">English (US)</option>
              <option value="1">In Active</option>
            </select>
          </div></> */}
      </div>
      {
        (profile?.company || profile?.expert) ?
          <div className="account-preference ">
            <Availability profile={profile} />
            <WorkingHours profile={profile} />
          </div>
          : <></>
      }


      {/* <div className="account-preference col-md-6"> */}
      {/* <h4>Push Notification</h4> */}
      {/* <div className="form-group">
          <h5>Notification interval</h5>
          <label>Receive notification in every</label>
          <select className="form-control">
            <option value="1">30 mins</option>
            <option value="1">In Active</option>
          </select>
        </div> */}
      {/* <div className="allow-notification">
          <h5>Allow notification</h5>
          <div className="slide-input">
            <label className="switch">
              <input type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
        </div> */}
      {/* <>
          <h5>Notify When</h5>
          <div className="new-task">
            <div className="allow-notification">
              <h5>New task is assigned</h5>
              <div className="slide-input">
                <label className="switch">
                  <input type="checkbox" checked />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <div className="allow-notification">
              <h5>Client has added a new milestone</h5>
              <div className="slide-input">
                <label className="switch">
                  <input type="checkbox" checked />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <div className="allow-notification">
              <h5>Task is due today</h5>
              <div className="slide-input">
                <label className="switch">
                  <input type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          <div className="form-group">
            <h5>Reminder</h5>
            <label>Send reminders</label>
            <select className="form-control">
              <option value="1">A day before</option>
              <option value="1">In Active</option>
            </select>
          </div>
        </> */}
      <PushNotification />
      {/* </div> */}
    </div>
  );
}
